import { sendShortMsg } from '@/services/login'
// import { recordEvent } from '@/utils/zhuge'
import { Button, message } from 'antd'
import React, { FC, useEffect, useRef, useState } from 'react'
import './index.less'

interface CountdownButtonProps {
	phone: string | number // 手机号
	type: string // "操作类型("注册发送消息": register, "重置密码发送消息":resetMm, "绑定手机号发送消":modifyPhone, "手机登录发送//信息":login, "绑定手机发送消息":bindPhone, "用户设置解锁发送消息",unlock)"
	duration?: number // 倒计时时长(s) 默认60秒
	className?: string
	disabled?: boolean // 是否禁用
}

const CountdownButton: FC<CountdownButtonProps> = ({
	phone,
	type,
	duration = 60,
	className,
	disabled = false,
}) => {
	const timer = useRef<any>(null)
	const [countTime, setCountTime] = useState(0)
	const [sendBtnClickable, setSendBtnClickable] = useState<boolean>(true)

	useEffect(() => {
		timer.current && clearInterval(timer.current)
		return () => {
			timer.current && clearInterval(timer.current)
		}
	}, [])

	// 验证码倒计时
	useEffect(() => {
		if (countTime === duration) {
			timer.current = setInterval(() => {
				setCountTime(time => --time)
			}, 1000)
		} else if (countTime === 0) {
			clearInterval(timer.current)
		}
	}, [countTime])

	// 防止发送按钮多次点击
	useEffect(() => {
		if (!sendBtnClickable) {
			setTimeout(() => {
				setSendBtnClickable(true)
			}, 1000)
		}
	}, [sendBtnClickable])

	// 发送验证码
	const sendMsg = () => {
		if (!sendBtnClickable) {
			return
		} else {
			setSendBtnClickable(false)
		}
		if (countTime !== 0) {
			message.warning(`请在${countTime}秒后重试`)
			return
		}
		if (phone.toString().length !== 11) {
			message.warning('请填写正确的手机号')
			return
		}
		sendShortMsg({
			phoneNo: phone.toString(),
			motion: type ?? 'login',
		})
			.then(res => {
				if (res?.code === 200) {
					setCountTime(duration)
				} else {
					message.error(res.message)
				}
			})
			.catch(error => {
				console.log(error.message)
			})
	}

	return (
		<Button
			className={`btnSendMsg ${className} ${
				countTime !== 0 ? 'btnSendMsgDisabled' : ''
			}`}
			onClick={() => {
				if (!disabled) {
					sendMsg()
					// recordEvent('发送验证码', {}, () => {})
				}
			}}
		>
			{countTime ? `${countTime}秒后获取` : '获取验证码'}
		</Button>
	)
}

export default CountdownButton
